import { useState } from 'react'
import styles from './kdt-growth-2nd.module.scss'

interface ICurriculumPcProps {
  curriculumDetailList: {
    id: number
    step: string
    titlePc: string
    desc: string
    descList: string[]
  }[]
}

const CurriculumTab = ({ curriculumDetailList }: ICurriculumPcProps) => {
  const [value, setValue] = useState(curriculumDetailList[0]?.titlePc || '')
  const onClickTab = (titlePc: string) => {
    setValue(titlePc)
  }
  const selectedDetail = curriculumDetailList.find(detail => detail.titlePc === value)

  return (
    <>
      <div className="w-[395px] shrink-0 px-8 py-7">
        <ul className={`${styles.curriculum_accordion_dot_ul} flex flex-col gap-3`}>
          {curriculumDetailList.map(detail => (
            <li key={detail.titlePc} className="flex flex-row items-center gap-8">
              <div
                className={`${
                  value === detail.titlePc
                    ? 'border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                    : 'border-label-alternative bg-[#383838]'
                } z-10 h-3 w-3 rounded-full border-[2px]`}
              ></div>
              <div
                className={`${
                  value === detail.titlePc
                    ? 'border-yellow-450 bg-[rgba(255,119,16,0.10)]'
                    : 'border-[#525252] bg-[#2E2E2E]'
                } flex flex-1 cursor-pointer flex-col gap-1 rounded border px-5 py-4`}
                onClick={() => onClickTab(detail.titlePc)}
              >
                {detail.step && (
                  <p
                    className={`${
                      value === detail.titlePc ? 'opacity-100' : 'opacity-50'
                    } text-base font-bold text-yellow-450`}
                  >
                    {detail.step}
                  </p>
                )}
                <h6
                  className={`${
                    value === detail.titlePc ? 'text-white' : 'text-[rgba(255,255,255,0.50)]'
                  } whitespace-pre-line text-xl font-bold`}
                >
                  {detail.titlePc}
                </h6>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-1 flex-col gap-6 px-8 py-7">
        {selectedDetail && (
          <>
            <h6 className="text-2xl font-bold text-white">{selectedDetail.titlePc}</h6>
            <div className="rounded bg-[#2F2F2F] px-6 py-5">
              <p className="text-base font-semibold leading-normal text-white">
                {selectedDetail.desc}
              </p>
              <div className="mt-5 flex flex-col gap-0.5 border-t border-[#404040] pt-5">
                {selectedDetail.descList.map(desc => (
                  <div key={desc}>
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_section7} text-base text-label-assistive`}
                    >
                      {desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default CurriculumTab
